import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UntypedFormGroup, Validators, FormControl, UntypedFormBuilder, } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import * as _moment from 'moment';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { UserMultiColumnDropdownComponent } from '../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { constants } from 'src/app/shared/common/contants';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { FilterspopupComponent } from './filterspopup/filterspopup.component';
import { FitersserviceService } from './filterspopup/fitersservice.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PivotConfigurationPopupComponent } from './pivot-configuration-popup/pivot-configuration-popup.component';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';

const moment =  _moment;

export interface ConditionalOPeratorTypeWhere {
  name: string,
  value: string
}

export interface LogicalOperatorTypeWhere {
  name: string,
  value: string
}

@Component({
    selector: 'app-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
    standalone: false
})
export class FiltersComponent implements OnInit {
  whereData = { "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "","enterValueWhereDate":"","logicalOperatorWhere": "" };
  where = [];
  showFilter:boolean = false;
  selectedFieldsDataToPush: any = [];
  butttonName
  editMyDataSet: any
  validations_form: UntypedFormGroup;
  validation_messages
  formValidWhere: UntypedFormGroup;
  fieldChange:boolean = true;
  dateChange:boolean = false;
  whereValueDateFormat = moment(null)
  fieldsData: any = [];
  dataSetObject = {
    datasetname: '',
    accesstype: '',
    fieldslist: '',
    userid: '',
    objectid: '',
    createdDate: '',
    createdBy: '',
    lastModifiedDate: '',
    lastModifiedBy: '',
    filtername: '',
    filterdescription: ''
  }
  
backgroundColorScreen="";
buttonColor="";
columnDefs;
rowClassRules;
defaultColDef;
rowSelectionForTablesFields;
rowSelection;

paginationPageSize;

paginationNumberFormatter;

lastpage;

currentpage;

nextpage;

nextpageplusone;

totalpages;

buttonIdList: any = [];
pagesize;
components: any;
gridApi;
getdata;
show:boolean= false;
status: any;

  constructor(private userRoutingModule:UserRoutingModule,private msg: ErrorMessages,private snackbar: MatSnackBar, private dialog: MatDialog, private validation: validationmethod,private fb: UntypedFormBuilder,private formFieldsTrimer: FormFieldsTrimer,private localStorageSettings: LocalStorageSettingsService,private constants: constants,private service:FitersserviceService,private spinner: NgxUiLoaderService,private reportLinkService:ReportlinksserviceService) {
    this.validation_messages = this.msg.reportMessages;
    this.components = {
      buttonRenderer: Actionbutton,
    }
   }


  ngOnInit() {
    
    /* @added by Chandra R
        @date 01-01-2025
        @@desc Below code enable and disable the buttons  in UI based on permission
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });

    this.columnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        values:this.buttonIdList,
        edit: this.EditIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      }, width: 250
    },
      { headerName: 'Filter Name', headerTooltip: 'Filter Name', tooltipValueGetter: (params) => 'Filter Name : ' + params.value, field: 'filtername', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Filter Description', headerTooltip: 'Filter Description', tooltipValueGetter: (params) => 'Filter Description : ' + params.value, field: 'filterDescription', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Dataset', headerTooltip: 'Dataset', tooltipValueGetter: (params) => 'Dataset : ' + params.value, field: 'datasetname', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Filters', headerTooltip: 'Filters', tooltipValueGetter: (params) => 'Filters : ' + params.value, field: 'filters', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Sorting', headerTooltip: 'Sorting', tooltipValueGetter: (params) => 'Sorting : ' + params.value, field: 'sorting', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created By', headerTooltip: 'Created By', tooltipValueGetter: (params) => 'Created By : ' + params.value, field: 'createdBy', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created Date', headerTooltip: 'Created Date', tooltipValueGetter: (params) => 'Created Date : ' + params.value, field: 'createdDateAndTime', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Last Modified By', headerTooltip: 'Last Modified By', tooltipValueGetter: (params) => 'Last Modified By : ' + params.value, field: 'lastmodifiedBy', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Last Modified Date', headerTooltip: 'Last Modified Date', tooltipValueGetter: (params) => 'Last Modified Date : ' + params.value, field: 'lastModifiedDateAndTime', filter: 'agTextColumnFilter', width: 250 }
      
    ],
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelectionForTablesFields='multiple';
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };


    this.formValidWhere = this.fb.group({
      fieldsWhere: '',
      conditionalOperatorWhere: '',
      enterValueWhere: '',
      fieldsOrderBy: '',
      arrangeOrderBy: '',
      fieldsAggredateBy: '',
      arrangeaggregateBy: ''
    });

    this.validations_form = this.fb.group({
      selectdataSet: ''
    });

    
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

  }



 
      //excel export function
      onBtExport() {
        this.gridApi.api.exportDataAsCsv();
      }
    
      //pagination code
      onPaginationChanged() {
        if (this.gridApi.api) {
          this.lastpage = this.gridApi.api.paginationIsLastPageFound();
          this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
          this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
          this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
          this.totalpages = this.gridApi.api.paginationGetTotalPages()
        }
      }
      //this function is for going to the given page number 
      onSearchChange(searchValue: number) {
    
        this.gridApi.api.paginationGoToPage(searchValue - 1);
      }
    
      // below function is for changing the no of rows per page
      onPageSizeChanged() {
        var value = this.pagesize
        this.gridApi.api.setGridOption('paginationPageSize', Number(value));
      }
    
      // below function is for going to next page
      onBtNext() {
        console.log("next")
        this.gridApi.api.paginationGoToNextPage();
      }
    
      // below function for going to previous page
      onBtPrevious() {
        console.log("previous")
        this.gridApi.api.paginationGoToPreviousPage();
      }
    
      // below function for going to first page
      onBtFirst() {
        console.log("first")
        this.gridApi.api.paginationGoToFirstPage();
      }
    
      // below function for going to last page
      onBtLast() {
        console.log("last")
        this.gridApi.api.paginationGoToLastPage();
      }
      //pagination code ends
  onGridReady(params){
    this.gridApi = params;
    //this.gridColumnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
    params.api.setGridOption('rowData', [])
    this.service.retrieveFilters().subscribe(response=>{
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.api.setGridOption('rowData', this.getdata)

      } else {

        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.api.setGridOption('rowData', this.getdata)

      }
      this.spinner.stop();
    });
  }

  openSaveForm(buttonName){
    this.butttonName = buttonName;
      let dialogRef = this.dialog.open(FilterspopupComponent, {
        width: "70%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "85%",
        disableClose: true,
        data: { editData: {} },
      });
  
      // subcribe the popup after close
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        this.onGridReady(this.gridApi);
      });
  }

  refreshRun() {
    this.spinner.start();
    this.onGridReady(this.gridApi);
    this.spinner.stop();
  }

  deleteIcon(event) {
    console.log(event);
    if(event.rowData.status === "No"){
      this.snackbar.open("Selected Filter is already deleted","OK",{duration:5000});
      return;
    }
    if(confirm("Are you sure you want to delete this filter?")){
      this.spinner.start();
      this.service.deleteFilter(event.rowData.filtermanageId).subscribe(result=>{
        if(result.statusMessage === "Successfully record is deleted"){
          this.snackbar.open(result.statusMessage, "OK",{duration:5000});
        }else{
          this.snackbar.open("Cannot delete selected filter, it is linked to a report template", "OK",{duration:5000});
        }
        this.refreshRun();
        this.spinner.stop();
      });
    }
    
  }
  EditIcon(event){
    console.log(event);

    this.status = event.rowData.status;
    if (this.status == "Yes") {
      this.dialog.open(FilterspopupComponent, {
        width: "70%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "85%",
        data: { editData: event.rowData },
        disableClose: true,
        
      
      });
    } else {
      this.snackbar.open(
        "Cannot edit object group which is already deleted.",
        "OK",
        {
          duration: 8000,
        }
      );
    }
  }

  openPivotConfigurationPopup(){
    // this.butttonName = buttonName;
      let dialogRef = this.dialog.open(PivotConfigurationPopupComponent, {
        width: "90%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "95%",
        disableClose: true,
        data: { editData: {} },
      });
  
      // subcribe the popup after close
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        this.onGridReady(this.gridApi);
      });
  }

}
